
/**
 * Calc & Return Line Level FXTotal - This should always be 2dp value.
 * @param {*} FxPrice 
 * @param {*} QTY 
 * @returns 
 */
export function getFxLineTotal(FxPrice, QTY) {
    return (FxPrice * QTY).roundNumber(2);
}

/**
 * Calc & Return Line Level Tax Total
 * @param {*} FxLineTotal 
 * @param {*} TaxPcnt 
 * @returns 
 */
export function getFXTaxLineTotal(FxLineTotal, TaxPcnt) {
    if (TaxPcnt)
        return (FxLineTotal * (TaxPcnt / 100)).roundNumber(2);
    else return 0;
}

/**
 * Calc & Return Line Level Inc Tax Line Total
 * @param {*} FxLineTotal 
 * @param {*} FXTaxLineTotal 
 * @returns 
 */
export function getFXIncTaxLineTotal(FxLineTotal, FXTaxLineTotal) {
    return (FxLineTotal + FXTaxLineTotal).roundNumber(2);
}
